import React, {PureComponent} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {Button, Modal, ThemeContext} from '../';

class Confirm extends PureComponent {
  static propTypes = {
    theme: PropTypes.shape({}).isRequired,
    container: PropTypes.shape({}).isRequired,
    title: PropTypes.string,
    message: PropTypes.string.isRequired,
    okLabel: PropTypes.string,
    cancelLabel: PropTypes.string,
    proceed: PropTypes.func.isRequired,
    cancel: PropTypes.func,
  };

  static defaultProps = {
    okLabel: 'OK',
    cancelLabel: 'Cancel',
    title: 'Confirm',
    cancel: () => {},
  };

  constructor(props) {
    super(props);

    this.state = {show: true};
  }

  unmount() {
    const {container} = this.props;
    ReactDOM.unmountComponentAtNode(container);
  }

  close = () => {
    this.setState({show: false});

    this.unmount();
  };

  cancel = () => {
    const {cancel} = this.props;

    this.close();

    if (cancel) {
      cancel();
    }
  };

  done = () => {
    const {proceed} = this.props;

    this.setState({show: false});
    this.unmount();

    proceed();
  };

  render() {
    const {show} = this.state;
    const {
      theme = {},
      title,
      message,
      okLabel,
      cancelLabel,
    } = this.props;

    return (
      <ThemeContext.Provider value={theme}>
        <Modal
          title={title}
          isOpen={show}
          onClose={this.close}
        >
          {message && <div className="row_gap_l confirm-box__message">{message}</div>}
          <div className="row row_center">
            <Button
              handler={this.cancel}
              size="l"
              text={cancelLabel}
            />
            <Button
              size="l"
              type="submit"
              handler={this.done}
              text={okLabel}
            />
          </div>
        </Modal>
      </ThemeContext.Provider>
    );
  }
}

export default function confirm(props) {
  const container = document.createElement('div');

  ReactDOM.render(<Confirm {...props} container={container}/>, container);
}
